/**
 * @fileoverview Loading Fallback Component
 * Displays a loading indicator while lazy-loaded components are being fetched
 */

import React from 'react';
import './LoadingFallback.css';

const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-fallback" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingFallback;
